import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: `${process.env.REACT_APP_IDP_URL}`,
  realm: `${process.env.REACT_APP_IDP_REALM}`,
  clientId: `${process.env.REACT_APP_IDP_CLIENT_ID}`,
});

export default keycloak;
